import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/passport/login',
    method: 'post',
    data
  })
}

export function sendVcSms(data) {
  return request({
    url: '/passport/verification-code',
    method: 'post',
    data
  }).then(res => res.data)
}

export function getInfo(access_token) {
  return request({
    url: '/passport/info',
    method: 'get',
    params: { access_token }
  })
}
